import { useNavigate } from 'react-router-dom';
import { formatPts } from '../utils';
import Icon from './Icon';

export default function ClanRow({ row, rank, battle, maxPts }) {
  const navigate = useNavigate();
  const pct = maxPts > 0 ? Number(row.totalPoints) / maxPts * 100 : 0;
  const rankClass = rank <= 3 ? `rank-${rank}` : '';

  return (
    <div className={`clan-row clan-ladder-row ${rankClass}`}>
      <button
        className="clan-row-btn"
        onClick={() => navigate(`/clan-stats?clanId=${row.id}&battleId=${battle.id}`)}
      >
        <div className="clan-position">
          <span>Rank</span>
          <strong>#{rank}</strong>
        </div>

        <div className="clan-icon-ph">{row.name[0]?.toUpperCase()}</div>

        <div className="clan-name-cell">
          <span className="clan-name-text">{row.name}</span>
          <span className="clan-member-count">{row.playerCount} active players</span>
        </div>

        <div className="clan-pts-cell">
          <div className="clan-score-line">
            <span>Battle points</span>
            <strong>{formatPts(row.totalPoints)}</strong>
          </div>
          <div className="bar-track">
            <div
              className={`bar-fill${rank === 1 ? ' gold' : rank === 2 ? ' silver' : rank === 3 ? ' bronze' : ''}`}
              style={{ width: `${pct}%` }}
            />
          </div>
        </div>

        <span className="clan-open-label">Open roster <Icon name="arrow" size={16} /></span>
      </button>
    </div>
  );
}
